import type { Bonus, FaqItem, SessionModule } from '../types/content';
export const productName = 'MEGAPACK MAESTRO DE SESIONES';
export const ctaHref = '#oferta';
// URL del checkout. Los botones de compra de la oferta y del cierre disparan InitiateCheckout y redirigen aquí.
export const checkoutUrl = 'https://megapack-maestro-de-sesiones.impultienda.ar/checkout';
export const heroMeta = ['6 módulos especializados', '+300 páginas de material profesional', '100% digital', 'Acceso inmediato'];
export const problems = ['Pasar demasiado tiempo preparando cada sesión.', 'Tener muchas ideas y recursos dispersos pero ningún sistema organizado.', 'Quedarse pensando cómo abordar determinados momentos de una conversación.', 'Buscar preguntas o ejercicios minutos antes de una sesión.', 'Sentir que se repiten las mismas preguntas.', 'Tener que reconstruir una estructura desde cero para situaciones frecuentes.'];

// Portadas oficiales: se muestran tal cual, sin recortes ni modificaciones.
export const modules: SessionModule[] = [{
  number: '01',
  title: 'Trauma y Estrés Postraumático',
  description: 'Material organizado de consulta para orientar la preparación de sesiones relacionadas con trauma y estrés postraumático.',
  resources: ['Estructuras orientativas de sesión', 'Preguntas terapéuticas', 'Posibles aperturas', 'Intervenciones orientativas', 'Posibles cierres y próximos pasos'],
  tagline: 'Un punto de partida ordenado para temáticas sensibles.',
  coverImage: 'https://cdn.magicpatterns.com/uploads/jUPNGbGuvEPEoHfYgWsVxR/Imagen_de_ChatGPT_27_sept_2026,_01_49_39_p.m..png',
  coverWidth: 1024,
  coverHeight: 1536
}, {
  number: '02',
  title: 'Regulación Emocional',
  description: 'Recursos organizados para preparar sesiones relacionadas con autoestima, autoconcepto y desarrollo de la confianza.',
  resources: ['Estructuras orientativas de sesión', 'Preguntas para explorar autopercepción', 'Guías de conversación', 'Intervenciones orientativas', 'Posibles cierres y próximos pasos'],
  tagline: 'Más recursos para explorar lo que la persona piensa y siente sobre sí misma.',
  coverImage: 'https://cdn.magicpatterns.com/uploads/sw8xM93hQfcHcjQ74g91Sh/Imagen_de_ChatGPT_27_sept_2026,_01_35_55_p.m..png',
  coverWidth: 1134,
  coverHeight: 1400
}, {
  number: '03',
  title: 'Desafíos en la Crianza',
  description: 'Material de consulta para preparar sesiones vinculadas con desafíos de crianza, dinámicas familiares y acompañamiento a madres, padres y cuidadores.',
  resources: ['Estructuras orientativas de sesión', 'Preguntas para explorar situaciones familiares', 'Guías de conversación', 'Intervenciones orientativas', 'Posibles cierres y próximos pasos'],
  tagline: 'Un punto de partida para ordenar conversaciones complejas sobre crianza.',
  coverImage: 'https://cdn.magicpatterns.com/uploads/i5v7JoQbqT3FNZKqkM4TBP/Imagen_de_ChatGPT_27_sept_2026,_01_38_39_p.m..png',
  coverWidth: 1080,
  coverHeight: 1440
}, {
  number: '04',
  title: 'Ansiedad',
  description: 'Recursos organizados para consultar y adaptar al preparar sesiones relacionadas con ansiedad.',
  resources: ['Estructuras orientativas de sesión', 'Bancos de preguntas', 'Posibles aperturas', 'Preguntas para profundizar', 'Intervenciones y cierres orientativos'],
  tagline: 'Consultá rápidamente diferentes caminos para abordar la sesión.',
  coverImage: 'https://cdn.magicpatterns.com/uploads/qJjscQf9EkHkxVp5zoEZeb/Imagen_de_ChatGPT_27_sept_2026,_01_40_17_p.m..png',
  coverWidth: 1080,
  coverHeight: 1440
}, {
  number: '05',
  title: 'Depresión',
  description: 'Material profesional de consulta para organizar y preparar sesiones relacionadas con depresión.',
  resources: ['Estructuras orientativas de sesión', 'Preguntas terapéuticas', 'Guías de conversación', 'Intervenciones orientativas', 'Posibles cierres y próximos pasos'],
  tagline: 'Recursos organizados para no tener que empezar cada preparación desde cero.',
  coverImage: 'https://cdn.magicpatterns.com/uploads/vkn7oDfGXQECdfPqjA4cRG/Imagen_de_ChatGPT_27_sept_2026,_01_41_57_p.m..png',
  coverWidth: 1024,
  coverHeight: 1536
}, {
  number: '06',
  title: 'Problemas de Pareja y Relaciones',
  description: 'Material de consulta para preparar sesiones relacionadas con conflictos de pareja, comunicación y relaciones interpersonales.',
  resources: ['Estructuras orientativas de sesión', 'Preguntas para explorar conflictos', 'Guías de conversación', 'Intervenciones orientativas', 'Posibles cierres y próximos pasos'],
  tagline: 'Más puntos de partida para abordar conversaciones y dinámicas relacionales.',
  coverImage: 'https://cdn.magicpatterns.com/uploads/rWTjDLNL2CtXsXwCfCvYza/Imagen_de_ChatGPT_27_sept_2026,_01_43_27_p.m..png',
  coverWidth: 1024,
  coverHeight: 1536
}];
export const includedItems = ['Módulo 1 — Trauma y Estrés Postraumático', 'Módulo 2 — Regulación Emocional', 'Módulo 3 — Desafíos en la Crianza', 'Módulo 4 — Ansiedad', 'Módulo 5 — Depresión', 'Módulo 6 — Problemas de Pareja y Relaciones', 'Más de 300 páginas de material'];
export const bonuses: Bonus[] = [{
  label: 'BONO #1',
  name: '[Nombre del bono]',
  description: '[Descripción breve del bono: qué incluye y cómo ayuda en la preparación de sesiones.]',
  value: '$[XX]'
}, {
  label: 'BONO #2',
  name: '[Nombre del bono]',
  description: '[Descripción breve del bono: qué incluye y cómo ayuda en la preparación de sesiones.]',
  value: '$[XX]'
}, {
  label: 'BONO #3',
  name: '[Nombre del bono]',
  description: '[Descripción breve del bono: qué incluye y cómo ayuda en la preparación de sesiones.]',
  value: '$[XX]'
}, {
  label: 'BONO #4',
  name: '[Nombre del bono]',
  description: '[Descripción breve del bono: qué incluye y cómo ayuda en la preparación de sesiones.]',
  value: '$[XX]'
}, {
  label: 'BONO #5',
  name: '[Nombre del bono]',
  description: '[Descripción breve del bono: qué incluye y cómo ayuda en la preparación de sesiones.]',
  value: '$[XX]'
}];
export const pricing = {
  totalValue: '$[XXX]',
  bonusTotal: '$[XXX]',
  today: '$[PRECIO]'
};

// Duración del contador del banner superior (en horas), contada desde la primera visita de cada usuario.
export const offerCountdownHours = 24;
export const trustItems = ['Pago seguro', 'Acceso inmediato', 'Garantía de [X] días', 'Producto digital'];
export const guarantee = {
  days: '[X]',
  text: '[Texto editable: describí aquí las condiciones reales de la garantía y del proceso de devolución — plazo, cómo solicitarla y a qué canal escribir.]'
};

// IMPORTANTE: testimonios y nombres PLACEHOLDER FICTICIOS, solo para visualizar la landing.
// Reemplazar por testimonios reales (con autorización) antes de publicar.
export const testimonials = [{
  quote: 'Antes perdía muchísimo tiempo buscando preguntas y organizando cada sesión. Ahora tengo todo ordenado por temática y encuentro en minutos un punto de partida para preparar lo que necesito.',
  name: 'Lic. Mariana R.',
  role: 'Psicóloga Clínica'
}, {
  quote: 'Los bancos de preguntas son de lo que más uso. Cuando quiero explorar un tema desde otro ángulo, abro el módulo correspondiente y encuentro nuevas preguntas y estructuras que puedo adaptar a la sesión.',
  name: 'Lic. Valentina M.',
  role: 'Psicóloga'
}, {
  quote: 'Me sorprendió la cantidad y la organización del material. No son recursos sueltos: está estructurado de una forma que hace muy fácil consultar lo que necesitás y adaptarlo a tu manera de trabajar.',
  name: 'Lic. Marcelo P.',
  role: 'Psicólogo Clínico'
}];
export const faqs: FaqItem[] = [{
  question: '¿Cómo recibo el material?',
  answer: 'Después de confirmar el pago, obtenés acceso digital al material.'
}, {
  question: '¿Es un producto físico?',
  answer: 'No. MEGAPACK MAESTRO DE SESIONES es un producto 100% digital.'
}, {
  question: '¿Cuánto tiempo tengo acceso?',
  answer: 'Acceso de por vida.'
}, {
  question: '¿Puedo imprimir los materiales?',
  answer: 'Los archivos se entregan en PDF y pueden consultarse digitalmente o imprimirse para uso personal/profesional según las condiciones de licencia.'
}, {
  question: '¿El material reemplaza mi formación o criterio profesional?',
  answer: 'No. Los recursos están diseñados como material educativo y de apoyo para profesionales. Deben adaptarse al contexto, necesidades del consultante, formación, criterio profesional y normativa aplicable.'
}, {
  question: '¿Sirve para profesionales que recién comienzan?',
  answer: 'El material está diseñado para facilitar la organización y consulta de recursos, pero no reemplaza formación, supervisión ni habilitación profesional.'
}, {
  question: '[Agregar pregunta]',
  answer: '[Agregar respuesta]'
}];
export const disclaimer = 'MEGAPACK MAESTRO DE SESIONES es un recurso educativo y de apoyo profesional. No sustituye formación académica, supervisión clínica, evaluación individual, diagnóstico, tratamiento, criterio profesional ni protocolos de emergencia. Cada profesional es responsable de evaluar la pertinencia de los recursos según cada caso, su formación, alcance profesional y normativa aplicable.';
export const footerLinks = ['Términos y Condiciones', 'Política de Privacidad', 'Política de Reembolso', 'Contacto / Soporte'];